/*--############################################################################
# Filename : MST44_054INS.vue                                                  
# Description : 마스터관리 > POS 마스터 > 결제키 설정(#)                        
# Date :2025-05-14                                                             
# Author : 권맑음                     
################################################################################*/
<template>
  <!-- 조회 조건 -->
  <div class="flex justify-between items-center w-full overflow-y-hidden">
    <PageName></PageName>
    <div class="flex justify-center mr-10 space-x-2 pr-5">
      <button @click="searchButton" class="button search md:w-auto w-14">
        조회
      </button>

      <button @click="saveButton" class="button save w-auto">저장</button>
      <button @click="copyButton" class="button copy w-auto">복사</button>
    </div>
  </div>
  <br />
  <div
    class="flex justify-start space-x-5 bg-gray-200 rounded-lg md:h-16 h-24 items-center">
    <PickStore
      @areaCd="handleStoreAreaCd"
      @update:storeCd="handleStoreCd"
      @posNo="handlePosNo"
      :showPosNo="true"
      :showPayType="true"
      @storeNm="handlestoreNm"
      @update:ischanged="handleinitAll"
      @update:ischanged2="searchinit"
      @updatePaymentType="updatePaymentType"></PickStore>
  </div>

  <div class="z-50">
    <DupliPopUp3
      :isVisible="showPopup2"
      @close="showPopup2 = false"
      :storeCd="nowStoreCd"
      :poskiosk="'getStoreDistinctList'"
      :storeNm="clickedStoreNm"
      :areaCd="nowStoreAreaCd"
      :posNo="posNo"
      :screenType="currentpaymentCd"
      :screenList="screenList"
      :progname="'MST44_054INS_VUE'"
      :dupliapiname="'DUPLIPAYKEY'"
      :progid="2"
      :naming="'POS번호'">
    </DupliPopUp3>
  </div>

  <div
    v-if="changeScreenKey"
    class="fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center z-50">
    <div class="bg-white p-6 rounded shadow-lg w-[25%] h-[40%]">
      <h2 class="text-lg font-bold">화면키 수정</h2>
      <div class="flex flex-col justify-start h-12">
        <div>
          <p>화면키명</p>
        </div>
        <div class="h-full w-full rounded-lg">
          <input
            type="text"
            class="border border-gray-400 pl-1 h-full w-full rounded-lg"
            v-model="currentscreenKeyNm" />
        </div>
      </div>

      <div
        v-if="currentpaymentCd == 3"
        class="flex flex-col justify-start h-12">
        <div>
          <p>화면키 유형</p>
        </div>
        <div class="h-full w-full rounded-lg">
          <select
            name=""
            id=""
            class="border border-gray-400 pl-1 h-full w-full rounded-lg"
            v-model="currentProduct"
            :disabled="showEditProduct">
            <option :value="0">기본</option>
            <option :value="1">품목할인</option>
          </select>
        </div>
      </div>
      <div
        v-if="currentpaymentCd == 3"
        class="flex flex-col mt-5 justify-start items-start">
        <div>※ 화면키는 기본 또는 품목할인으로 유형을 선택할 수 있습니다.</div>
        <div>※ 품목할인은 매장 당 하나의 화면키만 설정할 수 있습니다.</div>
        <div>
          ※ 화면키 유형이 품목할인인 경우, 결제코드를 등록하거나 수정할 수
          없으며, 품목할인 결제코드가 자동으로 노출됩니다.
        </div>
      </div>
      <div class="flex justify-center space-x-3 w-full h-16">
        <button
          @click="confirmScreenKey()"
          class="mt-4 p-2 bg-blue-500 text-white rounded">
          확인
        </button>
        <button
          @click="exitScreenKey"
          class="mt-4 p-2 bg-blue-500 text-white rounded">
          닫기
        </button>
      </div>
    </div>
  </div>

  <div
    v-if="addscreenKey"
    class="fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center z-50">
    <div class="bg-white p-6 rounded shadow-lg w-[25%] h-[40%]">
      <h2 class="text-lg font-bold">화면키 추가</h2>
      <div class="flex flex-col justify-start h-12">
        <div>
          <p>화면키명</p>
        </div>
        <div class="h-full w-full rounded-sm">
          <input
            type="text"
            class="border border-gray-400 pl-1 h-14 w-full rounded-sm"
            v-model="currentscreenKeyNm" />
        </div>
      </div>
      <div
        v-if="currentpaymentCd == 3"
        class="flex flex-col justify-start h-12 mt-3">
        <div>
          <p>화면키 유형</p>
        </div>
        <div class="h-full w-full rounded-lg">
          <select
            class="border border-gray-400 pl-1 h-full w-full rounded-lg"
            v-model="currentProduct">
            <option :value="0">기본</option>
            <option :value="1">품목할인</option>
          </select>
        </div>
      </div>
      <div class="flex justify-center space-x-3 w-full h-16 mt-8">
        <button
          @click="confirmaddScreenKey()"
          class="mt-4 p-2 bg-blue-500 text-white rounded">
          확인
        </button>
        <button
          @click="exitScreenKey"
          class="mt-4 p-2 bg-blue-500 text-white rounded">
          닫기
        </button>
      </div>
    </div>
  </div>
  <!-- 그리드 영역-->
  <!-- 드래그 영역-->
  <div
    v-show="showChangeScreenKey"
    class="fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center z-50">
    <div class="bg-white p-6 rounded shadow-lg w-2/3 h-3/4 overflow-auto">
      <div class="border-gray-500 text-2xl">화면키 순서 변경</div>
      <div class="border-gray-500 text-xl">
        화면키를 끌어서 이동하면 순서가 변경됩니다.
      </div>
      <!-- VueDraggableNext 사용 -->
      <VueDraggableNext
        v-model="ScreenKeyOrigin"
        :group="{ name: 'subCategory', pull: 'clone', put: true }"
        class="space-y-2"
        :move="onMove2"
        @end="onEnd2">
        <div
          v-for="(item, index) in ScreenKeyOrigin"
          class="p-4 bg-gray-200 rounded-lg shadow-md cursor-move h-12"
          v-show="item && item.strScreenName !== ''">
          <p>{{ item.strScreenName }}</p>
        </div>
      </VueDraggableNext>

      <div class="flex justify-center space-x-3">
        <button
          @click="showScreenKeysOrder"
          class="mt-4 p-2 bg-blue-500 text-white rounded">
          닫기
        </button>
      </div>
    </div>
  </div>
  <span
    class="h-5 mt-3 flex justify-between items-center w-[900px] ml-[700px] z-40">
    <h1 class="font-bold text-xl z-40">결제키 설정</h1>
    <span class="flex space-x-3 ml-32 pl-56 items-center"
      >순서변경 &nbsp; &nbsp;<label class="z-40"
        ><input
          type="radio"
          name="changingMode"
          @click.stop="changingMode(1)"
          checked />교체하기 </label
      ><label class="z-40"
        ><input
          type="radio"
          name="changingMode"
          @click.stop="changingMode(2)" />밀어내기</label
      ><button class="whitebutton z-40" @click.stop="deletekey">
        삭제
      </button></span
    >
  </span>
  <div class="flex h-[65vh] w-full -mt-5">
    <div class="flex flex-col w-3/5 h-5/6">
      <div
        class="flex justify-between mt-0 ml-10 w-full border-b border-b-gray-300">
        <div class="font-bold text-xl w-auto">
          <!-- <button class="contents_tab-button " :class="{'text-blue-600' : currentMenu==false }" @click="showMenus(1)">메뉴관리</button> -->
          {{ currentpaymentType }}&nbsp;결제키선택
        </div>
        <div class="mt-3">
          <!-- <button class="whitebutton" @click="searchAmountList3">조회</button> -->
          <button class="whitebutton" @click="movePage">추가</button>
        </div>
      </div>
      <div class="h-full" v-show="currentMenu == false">
        <div
          class="mt-3 ml-10 grid grid-cols-[1fr,3fr] grid-rows-2 gap-0 w-full">
          <div class="customtableIndex border border-gray-400 rounded-l-lg">
            결제코드/명
          </div>
          <div class="px-1 py-1 border border-gray-300 rounded-r-lg">
            <input
              type="text"
              class="border w-full h-full px-1 border-gray-400 rounded-lg"
              @input="searchAmountList" />
          </div>
        </div>
        <div class="ml-10 -mt-9 w-full h-full">
          <Realgrid
            class="w-full h-full"
            :progname="'MST44_054INS_VUE'"
            :progid="1"
            :rowData="rowData"
            :showGrid="showGrid"
            :showCheckBar="false"
            @selcetedrowData="selcetedrowData"
            :searchWord="searchword1"
            :searchColId="'lngCode,strName'"></Realgrid>
          <div class="flex justify-start">
            ※ 사용여부가 미사용인 결제코드는 목록에서 노출되지 않습니다.
          </div>
          <div class="flex justify-start">
            ※ 복사시 결제코드 항목을 추가해야 결제키 화면에 노출됩니다.
          </div>
        </div>
      </div>
    </div>
    <div class="grid grid-rows-[1fr,4fr] grid-cols-1 ml-10 w-full h-full z-20">
      <div
        class="flex h-full w-[86%] mt-10 items-start justify-center"
        v-show="afterSearch">
        <div
          class="grid grid-cols-4 grid-rows-1 gap-x-1 ml-10 mt-0 w-full h-full">
          <div
            v-for="(item, index) in ScreenKeys"
            class="custom-grid-style w-[174px] h-[80px]"
            :class="{
              '!bg-orange-500 !border-blue-700':
                clickedScreenKeyIndex == index && clickedScreenOrMenu == false,
            }"
            @click="
              clickedScreenKeyIndex = index;
              clickedScreenKeys();
            ">
            <p
              v-if="item.strScreenName != ''"
              @click="showKeys(item.intScreenNo)"
              class="flex items-center justify-center w-full h-full">
              <button class="">{{ item.strScreenName }}</button
              ><button
                @click.stop="
                  editScreenKey(
                    item.intScreenNo,
                    item.strScreenName,
                    item.itemDiscYn
                  )
                ">
                <font-awesome-icon :icon="['far', 'pen-to-square']" />
              </button>
            </p>
            <p
              v-else-if="item.new == true"
              @click="addScreenKey(index)"
              class="flex items-center justify-center w-full h-full">
              <button
                class="w-full h-full text-gray-300 flex justify-center items-center">
                <img src="../../assets/ic_add_gray_24.png" alt="" /> 화면키 추가
              </button>
            </p>
            <p v-else class="flex items-center justify-center"></p>
          </div>
        </div>
        <div class="flex mt-5 ml-2 w-36 h-1/5">
          <button
            class="border border-[#CCCCCC] w-full h-full rounded-md flex justify-center items-center"
            @click="showPrev">
            <img
              src="../../assets/table-left.svg"
              alt=""
              class="w-full h-full object-cover rounded-md" /></button
          ><button
            class="border border-[#CCCCCC] h-full w-full rounded-md flex justify-center items-center"
            @click="showScreenKeysOrder">
            <img src="../../assets/table-change_2.svg" alt="" /></button
          ><button
            class="border border-[#CCCCCC] w-full h-full rounded-md flex justify-center items-center"
            @click="showNext">
            <img
              src="../../assets/table-right.svg"
              alt=""
              class="w-full h-full object-cover rounded-md" />
          </button>
        </div>
      </div>

      <div v-show="afterSearch" class="flex mt-4 w-11/12 h-5/6">
        <div class="flex w-full h-full">
          <VueDraggableNext
            v-model="items"
            :move="onMove"
            @end="onEnd"
            animation="200"
            class="grid grid-cols-5 grid-rows-6 ml-10 mt-4 w-full h-full gap-1">
            <div
              v-for="(item, index) in items"
              class="custom-grid-style"
              :class="{
                '!bg-orange-500 !border-blue-700':
                  clickedMenuKey == index && clickedScreenOrMenu == true,
              }"
              @click="
                index !== 29 &&
                  item.itemDiscYn == 0 &&
                  (saveMenuKeyposition(index),
                  (clickedMenuKey = index),
                  clickedMenukeys())
              ">
              <span
                class="flex flex-col items-center justify-center w-full h-full rounded-lg"
                :class="{ '!bg-gray-300': index == 29 || item.itemDiscYn == 1 }"
                ><span class="flex justify-center items-center">{{
                  item ? item.lngKeyScrNo : ""
                }}</span
                ><span class="flex justify-center items-center">{{
                  item ? item.strName : ""
                }}</span></span
              >
            </div>
          </VueDraggableNext>
        </div>
      </div>
    </div>
  </div>
  <!-- 드래그 영역-->
</template>

<script setup>
import {
  getAllScreenList,
  getAmountList,
  saveAllMenuKey2,
  saveScreenKeys2,
} from "@/api/master";
/**
 *  경고창 호출 라이브러리
 *  */

import Swal from "sweetalert2";
/*
 * 공통 표준  Function
 */

import { onMounted, ref, watch } from "vue";
/*
 * 드래그 라이브러리 호출
 */

import { VueDraggableNext } from "vue-draggable-next";
/**
 *  Vuex 상태관리 및 로그인세션 관련 라이브러리
 */

import { useStore } from "vuex";

import DupliPopUp3 from "@/components/dupliPopUp3.vue";
/**
 * 매장 공통 컴포넌트
 */

import PickStore from "@/components/pickStore.vue";
/**
 * 	그리드 생성
 */

import Realgrid from "@/components/realgrid.vue";
/**
 *  페이지로그 자동 입력
 *  */

import { insertPageLog } from "@/customFunc/customFunc";
/**
 *  페이지명 자동 입력 컴포넌트
 *  */

import PageName from "@/components/pageName.vue";
import Autocompletecomponet from "@/components/autocompletecomponet.vue";

/**
 * 	화면 Load시 실행 스크립트
 */

onMounted(async () => {
  const pageLog = await insertPageLog(store.state.activeTab2);
});
// 더미 데이터
const items = ref([]);
const clickedScreenKeyIndex = ref();
const ScreenKeyOrigin = ref([]);
const clickedMenuKey = ref();
const ScreenKeys = ref([]);
const currentMenuorTLU = ref(false);
/**
 *  그리드 검색어 세팅
 */

const searchword1 = ref();
/**
 *  그리드 검색어 세팅
 */

const searchword3 = ref();
const forsearchMain = ref("0");
const forsearchSub = ref("0");
const addscreenKey = ref(false);
const searchWord = ref("");
const searchWord2 = ref("");
const afterSearch2 = ref(false);
// 드래그 가능한 요소를 설정하는 메서드
const currentsubPage = ref(1);
const changeMode = ref(false);
const changingMode = (data) => {
  if (data == 1) {
    changeMode.value = false;
  } else {
    changeMode.value = true;
  }
};

const movePage = () => {
  store.state.moveOtherTab = {
    strUrl: "MIMASTER::MST36_001INS.xml",
    lngProgramID: 73645,
    strTitle: "결제 코드 등록.",
  };
};
const nowscreenNo = ref();
const clickedStoreNm = ref();
/**
 * 페이지 매장명 세팅
 */

const handlestoreNm = (newData) => {
  clickedStoreNm.value = newData;
};
const showPopup2 = ref(false);
const showChangeScreenKey = ref(false);
const confirmitem = ref([]);
const currentscreenKeyNm = ref("");
const maxSubCode = ref();
/**
 * 선택한 포스 번호 호출 함수
 */

const posNo = ref();
const changeScreenKey = ref(false);
const currmenuKeyPage = ref(1);
const AllscreenKeyPage = ref(1);
const currentSelectedMenuNm = ref("");
const currentMenu = ref(false);

/**
 * 복사 함수
 */

const copyButton = () => {
  if (afterSearch.value == false) {
    Swal.fire({
      title: "경고.",
      text: "조회를 먼저 해주세요",
      icon: "warning",
      confirmButtonText: "확인",
    });
    return;
  }
  showPopup2.value = true;
};

const showNext = () => {
  if (currentsubPage.value >= AllscreenKeyPage.value) {
    return;
  }
  currentsubPage.value++;

  addfor4ScreenKey();
};
const showPrev = () => {
  //comsole.log(ScreenKeyOrigin.value);
  if (currentsubPage.value == 1) {
    return;
  }
  currentsubPage.value--;
  ScreenKeys.value = ScreenKeyOrigin.value.slice(
    4 * (currentsubPage.value - 1),
    4 * (currentsubPage.value - 1) + 4
  );
};
const updateMenuKey = ref(false);

const nowStoreAreaCd = ref();
/**
 *  pickStore - 지역코드 세팅
 */

const handleStoreAreaCd = (newValue) => {
  nowStoreAreaCd.value = newValue;
  //comsole.log(nowStoreAreaCd.value);
};

const nowStoreCd = ref();
const afterCategory = ref(false);
/**
 * 페이지 매장 코드 세팅
 */

const handleStoreCd = async (newValue) => {
  if (newValue == "0") {
    afterSearch.value = false;
  }
  nowStoreCd.value = newValue;
};
const Category = ref([]);

const MenuGroup = ref([]);
const confirmitem2 = ref([]);
const SubMenuGroup = ref([]);
const rowData = ref([]);

const store = useStore();
const currentProduct = ref(0);
const showEditProduct = ref(false);
const userData = store.state.userData;
const groupCd = ref(userData.lngStoreGroup);
const modified = ref(false);
const afterSearch = ref(false);
const AmountList = ref([]);
const KeyList = ref([]);
const screenList = ref([]);
const clickedScreenOrMenu = ref(false);
const TLUList = ref([]);
const clickedScreenNo = ref();

const toNum = (value, fallback = 0) => {
  const num = Number(value);
  return Number.isFinite(num) ? num : fallback;
};

const getScreenOption = (item) =>
  toNum(item?.intScreenOption ?? item?.itemDiscYn, 0) === 1 ? 1 : 0;

const isItemDiscountPayCode = (item) => {
  if (!item) return false;
  return toNum(item.lngDiscType) === 1;
};

const uniqueItemDiscountCodes = (screenNo) => {
  const map = new Map();
  const addCode = (code, name, extra) => {
    if (code == null || code === "") return;
    const key = String(code);
    if (!map.has(key)) {
      map.set(key, {
        ...(extra || {}),
        lngCode: code,
        strName: name || extra?.strName || extra?.strKeyName || "",
      });
    }
  };

  (AmountList.value || []).forEach((item) => {
    if (!isItemDiscountPayCode(item)) return;
    addCode(item.lngCode, item.strName, item);
  });

  if (map.size === 0) {
    (KeyList.value || []).forEach((item) => {
      if (screenNo != null && item.intScreenNo != screenNo) return;
      addCode(
        item.lngKeyScrNo ?? item.lngCode,
        item.strName || item.strKeyName,
        item
      );
    });
  }

  return [...map.values()];
};

const applyPayCodeListByScreen = (isItemDiscScreen, screenNo) => {
  const list = AmountList.value || [];
  if (!isItemDiscScreen) {
    rowData.value = list;
    return;
  }
  rowData.value = uniqueItemDiscountCodes(screenNo);
};

const getScreenNoGroup = (type) => {
  const t = toNum(type);
  if (t === 3 || t === 4) return "3-4";
  return String(t);
};

const isSameScreenNoGroup = (item, type = currentpaymentCd.value) => {
  if (!item) return false;
  if (item.intScreenType == null || item.intScreenType === "") return true;
  return getScreenNoGroup(item.intScreenType) === getScreenNoGroup(type);
};

const nextScreenNoForType = () => {
  const nos = [...(ScreenKeyOrigin.value || []), ...(screenList.value || [])]
    .filter(
      (item) =>
        item &&
        item.intScreenNo !== "" &&
        item.intScreenNo != null &&
        isSameScreenNoGroup(item)
    )
    .map((item) => toNum(item.intScreenNo, 0))
    .filter((num) => num > 0);
  return (nos.length ? Math.max(...nos) : 0) + 1;
};

/**
 * 조회 함수
 */
const searchButton = async () => {
  changeMode.value = false;
  Category.value = [];
  items.value = [];

  if (nowStoreCd.value == "0" || nowStoreCd.value == undefined) {
    Swal.fire({
      title: "경고",
      text: "매장을 선택하세요.",
      icon: "warning",
      showCancelButton: false,
      confirmButtonColor: "#3085d6",
      allowOutsideClick: false,
    });
    return;
  }
  if (nowStoreAreaCd.value == "0" || nowStoreAreaCd.value == undefined) {
    Swal.fire({
      title: "경고",
      text: "POS번호를 선택하세요.",
      icon: "warning",
      showCancelButton: false,
      confirmButtonColor: "#3085d6",
      allowOutsideClick: false,
    });
    return;
  }
  store.state.loading = true;
  try {
    const res4 = await getAmountList(
      groupCd.value,
      nowStoreCd.value,
      nowStoreAreaCd.value,
      posNo.value,
      Number(currentpaymentCd.value)
    );
    //comsole.log(res4);
    AmountList.value = res4.data.AmountList || [];
    ScreenKeyOrigin.value = (res4.data.AmountScreenList || []).map((item) => {
      const option = getScreenOption(item);
      return {
        ...item,
        intScreenOption: option,
        itemDiscYn: option,
      };
    });
    //comsole.log(ScreenKeyOrigin.value);
    KeyList.value = res4.data.AmountKeyList;
    if (KeyList.value == null) {
      KeyList.value = [];
    }
    AmountList.value = AmountList.value.map((item) => {
      return {
        ...item,
        add: "추가",
      };
    });
    applyPayCodeListByScreen(false);

    const res2 = await getAllScreenList(
      groupCd.value,
      nowStoreCd.value,
      nowStoreAreaCd.value,
      posNo.value
    );
    screenList.value = res2.data.ALLScreenList;
    //comsole.log(screenList.value);
    //comsole.log(KeyList.value);

    addfor4ScreenKey();
    //comsole.log(ScreenKeyOrigin.value);
    AllscreenKeyPage.value = Math.ceil(ScreenKeyOrigin.value.length / 4);
    confirmitem.value = JSON.parse(JSON.stringify(KeyList.value));
    confirmitem2.value = JSON.parse(JSON.stringify(ScreenKeyOrigin.value));

    ////console.log(res4);
    ////console.log(res2);
  } catch (error) {
    afterSearch.value = false;
  } finally {
    store.state.loading = false; // 로딩 상태 종료
    modified.value = false;
    afterCategory.value = false;
    afterSearch.value = true;
    clickedMenuKey.value = -1;
  }

  calculateMaxSubCode();
};
const filteredSubMenuGroup = ref([]);
const setSubCd = () => {
  //comsole.log(forsearchMain.value);
  //comsole.log(SubMenuGroup.value);
  filteredSubMenuGroup.value = SubMenuGroup.value.filter(
    (item) => item.sublngMajor == forsearchMain.value
  );
  //comsole.log(filteredSubMenuGroup.value);
  forsearchSub.value = "0";
  searchAmountList3();
};
watch(forsearchSub, (newValue) => {
  searchAmountList3();
});
const clickedintScreenNo = ref();
const calculateMaxSubCode = () => {
  maxSubCode.value = Math.max(
    ...Category.value
      .filter((item) => item.SubCategory && item.SubCategory.length > 0)
      .flatMap((item) => item.SubCategory.map((sub) => Number(sub.SubCode)))
  );
};
const showKeys = (value) => {
  if (clickedintScreenNo.value != value) {
    currmenuKeyPage.value = 1;
  }
  //comsole.log(value);
  clickedintScreenNo.value = value;
  const currentScreen = ScreenKeyOrigin.value.find(
    (item) => item.intScreenNo == value
  );
  const thisProduct = getScreenOption(currentScreen) === 1;
  applyPayCodeListByScreen(thisProduct, value);
  if (thisProduct) {
    clickedRealIndex.value = "";
    const discCodes = uniqueItemDiscountCodes(value);
    items.value = Array.from({ length: 30 }, (_, index) => {
      const code = discCodes[index];
      if (code) {
        return {
          intKeySeq: index + 1,
          itemDiscYn: 1,
          lngKeyScrNo: code.lngCode,
          strName: code.strName,
        };
      }
      return {
        intKeySeq: index + 1,
        itemDiscYn: 1,
      };
    });
  } else {
    items.value = Array.from({ length: 30 }, (_, index) => ({
      intKeySeq: index + 1,
      itemDiscYn: 0,
    }));
    KeyList.value
      .filter((item) => item.intScreenNo == value)
      .forEach((item) => {
        const position = item.intKeySeq - (currmenuKeyPage.value - 1) * 30 - 1;
        if (position >= 0 && position < 30) {
          items.value[position] = item;
        }
      });
  }
  afterSearch2.value = true;
};
watch(ScreenKeys, (newvalue) => {
  AllscreenKeyPage.value = Math.floor(ScreenKeyOrigin.value.length / 4) + 1;
});

const showScreenKeysOrder = () => {
  showChangeScreenKey.value = !showChangeScreenKey.value;
};

let targetItemIndex2;
const onMove = (evt) => {
  // 예: 드래그 중 이동할 때의 조건 등을 설정할 수 있음
  if (changeMode.value == false) {
    targetItemIndex2 = Array.from(evt.from.children).indexOf(evt.related);
    //comsole.log(targetItemIndex2);

    return false;
  } else {
    return true;
  }
};
let dupliScreenKeyOrigin;
const onMove2 = () => {
  dupliScreenKeyOrigin = [...ScreenKeyOrigin.value];
  return true;
};
const clickedMove = ref(false);
const onEnd = (evt) => {
  if (targetItemIndex2 == undefined) {
    targetItemIndex2 = evt.oldIndex;
  }
  ////console.log(targetItemIndex2);
  ////console.log(items.value);
  const discyn = items.value.filter((item) => item.itemDiscYn == 1).length;
  if (evt.oldIndex == 29 || targetItemIndex2 == 29 || discyn > 0) {
    return;
  }
  // Swap을 처리할 조건
  if (changeMode.value === false) {
    const oldIndex = evt.oldIndex; // 드래그된 아이템의 기존 인덱스
    const swappedItems = [...items.value]; // items를 복사
    //comsole.log(oldIndex);
    //comsole.log(targetItemIndex2);
    const temp = swappedItems[oldIndex];

    swappedItems[oldIndex] = swappedItems[targetItemIndex2];

    swappedItems[targetItemIndex2] = temp;

    //comsole.log(swappedItems);
    // 배열을 업데이트
    //   items.value = swappedItems;

    items.value = swappedItems.map((item, index) => ({
      ...item, // 기존 객체의 다른 속성 유지
      intKeySeq: index + (currmenuKeyPage.value - 1) * 30 + 1, // 배열 순서대로 intKeySeq 재정렬
    }));
  } else {
    updateMenuKey.value = true;
    items.value = items.value.map((item, index) => ({
      ...item, // 기존 객체의 다른 속성 유지
      intKeySeq: index + (currmenuKeyPage.value - 1) * 30 + 1, // 배열 순서대로 intKeySeq 재정렬
    }));
  }
  //comsole.log(clickedintScreenNo.value);
  //comsole.log(KeyList.value);
  //comsole.log(currmenuKeyPage.value);
  KeyList.value = KeyList.value.filter(
    (item) => item.intScreenNo != clickedintScreenNo.value
  );
  //comsole.log(KeyList.value);
  items.value.forEach((item) => {
    if (item.lngKeyScrNo != undefined) {
      KeyList.value.push(item);
    }
  });

  clickedMenuKey.value =
    changeMode.value == false ? targetItemIndex2 : evt.newIndex;
  //comsole.log("Items:", items.value);
  //comsole.log("KeyList:", KeyList.value);
};
function formatNumber(value) {
  if (!value) return "";
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
const onEnd2 = (evt) => {
  const previous = Array.isArray(dupliScreenKeyOrigin)
    ? dupliScreenKeyOrigin
    : [];
  const current = ScreenKeyOrigin.value || [];
  const dragged = previous[evt?.oldIndex];

  // 저장값은 배열 순서가 아니라 intScreenNo다. 조회도 이 번호 순으로 돌아오므로
  // 드래그로 바뀐 위치에 기존 화면번호를 오름차순으로 다시 붙인다.
  if (previous.length > 0 && previous.length === current.length) {
    const sortedNos = previous
      .map((item) => toNum(item.intScreenNo, 0))
      .sort((a, b) => a - b);
    const oldToNew = new Map();

    current.forEach((item, index) => {
      const oldNo = toNum(item.intScreenNo, 0);
      const newNo = sortedNos[index];
      if (oldNo !== newNo) oldToNew.set(oldNo, newNo);
      item.intScreenNo = newNo;
    });

    if (oldToNew.size > 0) {
      (KeyList.value || []).forEach((item) => {
        const oldNo = toNum(item.intScreenNo, 0);
        if (oldToNew.has(oldNo)) item.intScreenNo = oldToNew.get(oldNo);
      });
      (screenList.value || []).forEach((item) => {
        if (toNum(item.intScreenType) !== toNum(currentpaymentCd.value)) return;
        const oldNo = toNum(item.intScreenNo, 0);
        if (oldToNew.has(oldNo)) item.intScreenNo = oldToNew.get(oldNo);
      });
      const clickedNo = toNum(clickedintScreenNo.value, 0);
      if (oldToNew.has(clickedNo)) {
        clickedintScreenNo.value = oldToNew.get(clickedNo);
      }
    }
  }

  addfor4ScreenKey();
  const focusNo = dragged
    ? toNum(dragged.intScreenNo, 0)
    : clickedintScreenNo.value;
  if (focusNo) showKeys(focusNo);
};
/**
 * 저장 함수
 */
const saveButton = async () => {
  if (afterSearch.value == false) {
    Swal.fire({
      title: "경고",
      text: "조회를 먼저 진행해주세요.",
      icon: "warning",
      confirmButtonText: "확인",
    });
    return;
  }
  if (
    JSON.stringify(confirmitem.value) == JSON.stringify(KeyList.value) &&
    JSON.stringify(confirmitem2.value) == JSON.stringify(ScreenKeyOrigin.value)
  ) {
    Swal.fire({
      title: "경고",
      text: "변경된 사항이 없습니다.",
      icon: "warning",
      confirmButtonText: "확인",
    });
    return;
  }

  Swal.fire({
    title: "저장",
    text: "저장 하시겠습니까?",
    icon: "question",
    showCancelButton: true,
    confirmButtonText: "저장",
    cancelButtonText: "취소",
  }).then(async (result) => {
    if (result.isConfirmed) {
      store.state.loading = true;
      try {
        const screenKeyNoarr = ScreenKeyOrigin.value.map(
          (item) => item.intScreenNo
        );
        const screenKeyNamearr = ScreenKeyOrigin.value.map(
          (item) => item.strScreenName
        );
        const screenKeyDisc = ScreenKeyOrigin.value.map((item) =>
          getScreenOption(item) === 1 ? "1" : "0"
        );

        const res = await saveScreenKeys2(
          groupCd.value,
          nowStoreCd.value,
          nowStoreAreaCd.value,
          posNo.value,
          screenKeyNoarr.join("\u200B"),
          screenKeyNamearr.join("\u200B"),
          screenKeyDisc.join("\u200B"),
          currentpaymentCd.value
        );

        const saveKeys = [...(KeyList.value || [])];
        ScreenKeyOrigin.value.forEach((screen) => {
          if (getScreenOption(screen) !== 1) return;
          if (saveKeys.some((item) => item.intScreenNo == screen.intScreenNo)) {
            return;
          }
          saveKeys.push({
            intKeySeq: 1,
            intScreenNo: screen.intScreenNo,
            lngKeyScrNo: 0,
            strName: "",
            itemDiscYn: 1,
          });
        });
        // 번호가 바뀌어 결제키가 빠진 화면은 삭제만 하도록 표시한다.
        // itemDiscYn 1 은 서버에서 해당 화면 키를 지우고 다시 넣지 않는다.
        ScreenKeyOrigin.value.forEach((screen) => {
          const screenNo = toNum(screen.intScreenNo, 0);
          if (!screenNo) return;
          if (saveKeys.some((item) => toNum(item.intScreenNo, 0) === screenNo)) {
            return;
          }
          saveKeys.push({
            intKeySeq: 1,
            intScreenNo: screenNo,
            lngKeyScrNo: 0,
            strName: "",
            itemDiscYn: 1,
          });
        });

        const intKeySeqs = saveKeys.map((item) => item.intKeySeq);
        const screenNumarr = saveKeys.map((item) => item.intScreenNo);
        const lngScrarr = saveKeys.map((item) => item.lngKeyScrNo);
        const menuKeyNmarr = saveKeys.map((item) => item.strName);
        const itemDiscYnarr = saveKeys.map((item) =>
          toNum(item.itemDiscYn) === 1 ? 1 : 0
        );
        //comsole.log(posNo.value);
        //comsole.log(intKeySeqs.join(","));
        //comsole.log(screenNumarr.join(","));
        //comsole.log(lngScrarr.join(","));
        //comsole.log(menuKeyNmarr.join(","));
        const res2 = await saveAllMenuKey2(
          groupCd.value,
          nowStoreCd.value,
          nowStoreAreaCd.value,
          posNo.value,
          intKeySeqs.join("\u200B"),
          screenNumarr.join("\u200B"),
          lngScrarr.join("\u200B"),
          menuKeyNmarr.join("\u200B"),
          currentpaymentCd.value,
          itemDiscYnarr.join("\u200B")
        );

        //comsole.log(res);
        //comsole.log(res2);
      } catch (error) {
      } finally {
        store.state.loading = false;
        Swal.fire({
          title: "저장 되었습니다.",
          confirmButtonText: "확인",
        });

        searchButton();
      }
    }
  });

  // 빈공간 데이터를 넣으려고하는데 안 들어가고 조회가 안됨 // 빈 칸에 대한 것도 데이터를 불러와야 메뉴키위치를 정할 수 있음.
};
let gridView;
let dataProvider;
const currentSelectedMenuCode = ref("");
const currentSelectedMenuImgUrl = ref("");
/**
 * 	화면 Load시 실행 스크립트
 */

onMounted(() => {
  showMenuKeys();
});

const showMenuKeys = () => {};

let gridView2;
let dataProvider2;
const clickedTLUCD = ref();
const clickedTLUNM = ref();
const clickedstrName = ref();
const clickedCode = ref();
/**
 * 선택한 행의 상세정보 셋팅
 */

const selcetedrowData = (newValue) => {
  const currentScreen = ScreenKeyOrigin.value.find(
    (item) => item.intScreenNo == clickedintScreenNo.value
  );
  if (getScreenOption(currentScreen) === 1) {
    return;
  }
  clickedstrName.value = newValue[1];
  clickedCode.value = newValue[0];
  addKey();
};

const searchAmountList = (e) => {
  searchword1.value = e.target.value;
};
const searchAmountList3 = (e) => {
  if (currentMenuorTLU.value == false) {
    const filteredList = AmountList.value.filter(
      (item) =>
        (forsearchMain.value === "0" ||
          item.majorGroupCd === forsearchMain.value) &&
        (forsearchSub.value === "0" ||
          item.subGroupCd === forsearchSub.value) &&
        (item.menuCd.includes(searchWord.value) ||
          item.menuNm.includes(searchWord.value))
    );
    dataProvider.setRows(filteredList);
  } else {
    const filteredList = TLUList.value.filter(
      (item) =>
        item.lngCode.toString().includes(searchWord2.value) ||
        item.strName.includes(searchWord2.value)
    );
    dataProvider2.setRows(filteredList);
  }
};

const currentpaymentType = ref("할인");
const currentpaymentCd = ref(3);
/**
 * 결제키 구분 세팅
 */

const updatePaymentType = (newValue) => {
  //comsole.log(newValue);
  currentpaymentCd.value = newValue;
  if (newValue == 3) {
    currentpaymentType.value = "할인";
  } else {
    currentpaymentType.value = "지불";
  }
  ScreenKeyOrigin.value = [];
  ScreenKeys.value = [];
  KeyList.value = [];
  rowData.value = [];
  items.value = [];
};

/**
 * pickStore - 포스번호 세팅
 */

const handlePosNo = (newValue) => {
  posNo.value = newValue;
  //comsole.log(posNo.value);
  //comsole.log(nowStoreAreaCd.value);
  if (
    nowStoreAreaCd.value != undefined &&
    posNo.value != undefined &&
    posNo.value != 0
  ) {
    searchButton();
  }
};

watch(
  () => AmountList.value,
  () => {
    showMenuKeys(); // MenuKeyList 값이 변경될 때마다 그리드 업데이트
  }
);

const editScreenKey = (value, value2, value3) => {
  currentscreenKeyNm.value = value2;
  //comsole.log(value3);
  currentProduct.value = toNum(value3) === 1 ? 1 : 0;
  clickedScreenNo.value = value;
  changeScreenKey.value = true;
  const disclength = ScreenKeyOrigin.value.filter(
    (item) => getScreenOption(item) === 1
  ).length;
  //comsole.log(ScreenKeyOrigin.value);
  //comsole.log(disclength);
  showEditProduct.value = disclength >= 1 && currentProduct.value !== 1;
};

const exitScreenKey = () => {
  changeScreenKey.value = false;
  addscreenKey.value = false;
};
const confirmScreenKey = () => {
  const index = ScreenKeyOrigin.value.findIndex(
    (item) => item.intScreenNo == clickedScreenNo.value
  );
  const nextOption =
    currentpaymentCd.value == 3 && toNum(currentProduct.value) === 1 ? 1 : 0;
  const applyScreenOption = () => {
    ScreenKeyOrigin.value[index].strScreenName = currentscreenKeyNm.value;
    ScreenKeyOrigin.value[index].itemDiscYn = nextOption;
    ScreenKeyOrigin.value[index].intScreenOption = nextOption;
    changeScreenKey.value = false;
    addfor4ScreenKey();
    currentscreenKeyNm.value = "";
    showKeys(clickedScreenNo.value);
    currentProduct.value = 0;
  };
  if (
    currentpaymentCd.value == 3 &&
    getScreenOption(ScreenKeyOrigin.value[index]) !== nextOption
  ) {
    Swal.fire({
      title: "변경",
      text: "화면키 유형을 변경하시면 해당 화면키의 결제키가 모두 초기화됩니다.",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "변경",
      cancelButtonText: "취소",
    }).then((result) => {
      if (result.isConfirmed) {
        KeyList.value = KeyList.value.filter(
          (item) => item.intScreenNo != clickedScreenNo.value
        );
        applyScreenOption();
      }
    });
  } else {
    applyScreenOption();
  }
};

const addfor4ScreenKey = () => {
  ScreenKeys.value = [
    ...ScreenKeyOrigin.value.slice(
      4 * (currentsubPage.value - 1),
      4 * (currentsubPage.value - 1) + 4
    ),
  ];
  //comsole.log(ScreenKeys.value);
  const validateScreenKeys = ScreenKeys.value.filter(
    (item) => item.intScreenNo != ""
  );
  if (validateScreenKeys.length < 4) {
    ScreenKeys.value.push({ strScreenName: "", intScreenNo: "", new: true });
    for (var i = 0; i < 3 - validateScreenKeys.length; i++) {
      ScreenKeys.value.push({ strScreenName: "", intScreenNo: "" });
    }
  }
};

const addfor30MenuKeys = () => {
  const length = items.value.length;
  if (length < 30) {
    for (var i = 0; i < 30 - length; i++) {
      items.value.push({ strScreenName: "", intScreenNo: "" });
    }
  }
};

const addScreenKey = (value) => {
  currentscreenKeyNm.value = "";
  currentProduct.value = 0;
  addscreenKey.value = true;
  //comsole.log(value);
  clickedScreenNo.value = value + 1;
};

const confirmaddScreenKey = () => {
  if (currentscreenKeyNm.value == "" || currentscreenKeyNm.value == null) {
    Swal.fire({
      title: "오류",
      text: "화면키 이름을 입력하세요.",
      icon: "error",
      confirmButtonText: "확인",
    });
    return;
  }
  const newScreenNo = nextScreenNoForType();
  const newScreenType = toNum(currentpaymentCd.value);
  const option =
    newScreenType === 3 && toNum(currentProduct.value) === 1 ? 1 : 0;

  ScreenKeyOrigin.value.push({
    strScreenName: currentscreenKeyNm.value,
    intScreenNo: newScreenNo,
    intScreenType: newScreenType,
    itemDiscYn: option,
    intScreenOption: option,
  });
  screenList.value = [
    ...(screenList.value || []),
    {
      strScreenName: currentscreenKeyNm.value,
      intScreenNo: newScreenNo,
      intScreenType: newScreenType,
      itemDiscYn: option,
      intScreenOption: option,
    },
  ];
  addscreenKey.value = false;
  addfor4ScreenKey();
  //comsole.log(ScreenKeyOrigin.value);
  currentscreenKeyNm.value = "";
  currentProduct.value = 0;
  clickedintScreenNo.value = newScreenNo;
  //comsole.log(clickedScreenNo.value);
  showKeys(newScreenNo);
};

const existMenuKey = ref(false);
const clickedRealIndex = ref();
const saveMenuKeyposition = (index) => {
  //comsole.log(clickedintScreenNo.value);
  //comsole.log(index);
  //comsole.log(items.value);
  clickedRealIndex.value = (currmenuKeyPage.value - 1) * 16 + index + 1;
  //comsole.log(clickedRealIndex.value);
};

const addKey = () => {
  const foraddIndex = KeyList.value.findIndex(
    (item) =>
      item.intPosNo == posNo.value &&
      item.intScreenNo == clickedintScreenNo.value &&
      item.intKeySeq == clickedRealIndex.value
  );

  //comsole.log(clickedintScreenNo.value);
  if (foraddIndex == -1) {
    KeyList.value.push({
      intKeyNo: currentpaymentCd.value,
      intKeySeq: clickedRealIndex.value,
      intPosNo: posNo.value,
      intScreenNo: clickedintScreenNo.value,
      lngKeyScrNo: Number(clickedCode.value),
      strName: clickedstrName.value,
      itemDiscYn: 0,
    });
  } else {
    KeyList.value[foraddIndex] = {
      intKeyNo: currentpaymentCd.value,
      intKeySeq: clickedRealIndex.value,
      intPosNo: posNo.value,
      intScreenNo: clickedintScreenNo.value,
      lngKeyScrNo: Number(clickedCode.value),
      strName: clickedstrName.value,
      itemDiscYn: 0,
    };
  }
  showKeys(clickedintScreenNo.value);
  //comsole.log(KeyList.value);
};

const addTLUKey = () => {
  //comsole.log(KeyList.value);
  const foraddIndex = KeyList.value.findIndex(
    (item) => item.intKeySeq == clickedRealIndex.value
  );
  //comsole.log(foraddIndex);
  if (foraddIndex == -1) {
    KeyList.value.push({
      intKeyNo: 6,
      intKeySeq: clickedRealIndex.value,
      intPosNo: posNo.value,
      intScreenNo: clickedintScreenNo.value,
      lngKeyscrNo: Number(clickedTLUCD.value),
      strKeyName: clickedTLUNM.value,
    });
  } else {
    KeyList.value[foraddIndex] = {
      intKeyNo: 6,
      intKeySeq: clickedRealIndex.value,
      intPosNo: posNo.value,
      intScreenNo: clickedintScreenNo.value,
      lngKeyscrNo: Number(clickedTLUCD.value),
      strKeyName: clickedTLUNM.value,
    };
  }
  showKeys(clickedintScreenNo.value);
};

/**
 * 삭제 버튼
 */

const deletekey = () => {
  if (clickedScreenOrMenu.value == false) {
    ScreenKeyOrigin.value = ScreenKeyOrigin.value.filter(
      (item) => item.intScreenNo != clickedintScreenNo.value
    );
    screenList.value = (screenList.value || []).filter(
      (item) =>
        !(
          item.intScreenNo == clickedintScreenNo.value &&
          toNum(item.intScreenType) === toNum(currentpaymentCd.value)
        )
    );
    addscreenKey.value = false;
    addfor4ScreenKey();

    KeyList.value = KeyList.value.filter(
      (item) => item.intScreenNo != clickedintScreenNo.value
    );
    currentscreenKeyNm.value = "";

    clickedintScreenNo.value = clickedintScreenNo.value + 1;
    showKeys(clickedintScreenNo.value);
  } else {
    KeyList.value = KeyList.value.filter(
      (item) =>
        item.intScreenNo != clickedintScreenNo.value ||
        item.intKeySeq != clickedRealIndex.value
    );
    //comsole.log(KeyList.value);
    showKeys(clickedintScreenNo.value);
  }
};

const clickedMenukeys = () => {
  clickedScreenOrMenu.value = true;
};
const clickedScreenKeys = () => {
  clickedScreenOrMenu.value = false;
};
/**
 * 조회 초기화
 */

const handleinitAll = (newvalue) => {
  AmountList.value = [];
  MenuGroup.value = [];
  SubMenuGroup.value = [];
  KeyList.value = [];
  ScreenKeyOrigin.value = [];
  TLUList.value = [];
  AllscreenKeyPage.value = "1";
  ScreenKeys.value = [];
  items.value = [];
  forsearchMain.value = "0";
  forsearchSub.value = "0";
  afterSearch.value = false;
  searchword1.value = "";
  searchword3.value = "";
  afterSearch.value = false;
};
/**
 * 조회 상태 초기화
 */

const searchinit = (newvalue) => {
  afterSearch.value = false;
};
</script>

<style scoped></style>
